module.exports = __webpack_public_path__ + "img/19.85319d40.jpg";